import { useState, useRef, useEffect } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { CaretDownIcon as CaretDown, CheckIcon as Check } from "@phosphor-icons/react";
import { useSuspendedAlert } from "@/context/SuspendedClientAlert";

// Menu a tendina cliente con barra di ricerca VISIBILE (digiti e vedi ciò che scrivi).
// extraOptions: voci fisse in cima (es. [{value:"all",label:"Tutti i clienti"}]).
export function ClientCombobox({
  clients = [], value, onChange, placeholder = "Seleziona cliente…",
  extraOptions = [], width = "w-full", className = "", testid, disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const listRef = useRef(null);
  // Riporta sempre la lista alla prima voce quando cambia la ricerca
  useEffect(() => { if (listRef.current) listRef.current.scrollTop = 0; }, [search]);
  const { alertSuspended } = useSuspendedAlert();
  const extra = extraOptions.find((o) => o.value === value);
  const current = (clients || []).find((c) => c.id === value);
  const text = extra ? extra.label : current ? current.ragione_sociale : "";
  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (!o) setSearch(""); }}>
      <PopoverTrigger asChild disabled={disabled}>
        <button type="button" data-testid={testid}
          className={`flex items-center justify-between gap-2 h-9 px-3 rounded-sm border border-input bg-white text-sm disabled:opacity-50 disabled:cursor-not-allowed ${width} ${className} ${!text ? "text-muted-foreground" : "text-foreground"}`}>
          <span className="truncate">{text || placeholder}</span>
          <CaretDown size={14} className="shrink-0 opacity-60" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="p-0 rounded-sm min-w-[260px] w-[var(--radix-popover-trigger-width)]"
        data-testid={testid ? `${testid}-popover` : undefined}>
        <Command>
          <CommandInput value={search} onValueChange={setSearch} placeholder="Cerca cliente…" data-testid={testid ? `${testid}-search` : undefined} />
          <CommandList ref={listRef} className="max-h-72">
            <CommandEmpty>Nessun cliente</CommandEmpty>
            <CommandGroup>
              {extraOptions.map((o) => (
                <CommandItem key={o.value} value={`__opt_${o.label}`} onSelect={() => { onChange(o.value); setOpen(false); }}
                  data-testid={testid ? `${testid}-opt-${o.value}` : undefined}>
                  <span className="flex-1 truncate">{o.label}</span>
                  {value === o.value && <Check size={15} weight="bold" className="text-primary shrink-0" />}
                </CommandItem>
              ))}
              {(clients || []).map((c) => (
                <CommandItem key={c.id} value={`${c.ragione_sociale} ${c.partita_iva || ""} ${c.citta || ""}`}
                  onSelect={() => { onChange(c.id); if (c.stato === "sospeso") alertSuspended(c); setOpen(false); }}
                  data-testid={testid ? `${testid}-opt-${c.id}` : undefined}>
                  <span className="flex-1 truncate">{c.ragione_sociale}{c.citta ? ` · ${c.citta}` : ""}</span>
                  {c.stato === "sospeso" && <span className="shrink-0 mr-1 rounded-sm bg-red-100 text-red-700 border border-red-200 px-1.5 py-0.5 text-[10px] font-semibold">Sospeso</span>}
                  {value === c.id && <Check size={15} weight="bold" className="text-primary shrink-0" />}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
